
























































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';
import he from 'he';

import VoteMixins from './mixins';

@Component
export default class VotePage extends mixins(Vue, VoteMixins) {
  onLoaded() {
    let title =
      `<span>${he.encode(this.subject!.Name)}:</span>` +
      '<i class=mx-1>' +
      `<span class=inst>${this.instructions}</span>`;
    '</i>';
    this.$store.commit('Header', title);
  }

  get instructions() {
    if (!this.subject) return '';
    if (process.env.VUE_APP_CLIENT == 'kantar') {
      return 'יש לסמן את המפלגה לה הצבעת';
    }
    let min = `<span class=num>${this.subject.Min}</span>`;
    let max = `<span class=num>${this.subject.Max}</span>`;

    if (this.subject.Min === this.subject.Max) {
      return this.$t('vs.vote.instructions.line1.all.' + this.pluralCount, [min]);
    } else if (this.subject.Min === 0) return this.$t('vs.vote.instructions.line1.max.' + this.pluralCount, [max]);
    else return this.$t('vs.vote.instructions.line1.minmax.' + this.pluralCount, [min, max]);
  }
}
